module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "基础信息",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "活动分类"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.activitycate),
      callback: function($$v) {
        _vm.$set(_vm.form, "activitycate", $$v)
      },
      expression: "form.activitycate"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "活动内容"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动内容"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", $$v)
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "排序"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "排序"
    },
    model: {
      value: (_vm.form.act_sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "act_sort", $$v)
      },
      expression: "form.act_sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片",
      "label-width": "100px",
      "prop": "img"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('img')
      }
    }
  }, [(_vm.form.img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), (_vm.form.activitycate == 5) ? _c('el-form-item', {
    attrs: {
      "label": "模板样式",
      "label-width": "100px"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.mubanChange
    },
    model: {
      value: (_vm.form.sc_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "sc_id", $$v)
      },
      expression: "form.sc_id"
    }
  }, _vm._l((_vm.sucaiData), function(item, i) {
    return _c('el-radio-button', {
      key: i,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.activitycate == 5) ? _c('el-form-item', {
    attrs: {
      "label": "模板背景",
      "label-width": "100px",
      "prop": "current_url"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('current_url')
      }
    }
  }, [(_vm.form.current_url) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.current_url
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n            温馨提示：修改模板时一定要仔细检查，替换的模板样式必须与固定模板样式保持一致；"), _c('br'), _vm._v("\n              如替换素材模板与固定样式不一致，分享素材会出现排版错乱，每次替换操作都将记录日志，请细心操作哦~\n          ")])]) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "绑定商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "设置商品",
      "shadow": "naver"
    }
  }, [(_vm.form.items.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品ID",
      "prop": "sku_id",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品货号",
      "prop": "sku_bn",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "prop": "sku_name",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.act_sort),
            callback: function($$v) {
              _vm.$set(scope.row, "act_sort", $$v)
            },
            expression: "scope.row.act_sort"
          }
        })]
      }
    }], null, false, 3934063766)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "营销图标ID",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "size": "mini"
          },
          model: {
            value: (scope.row.tui_icon),
            callback: function($$v) {
              _vm.$set(scope.row, "tui_icon", $$v)
            },
            expression: "scope.row.tui_icon"
          }
        })]
      }
    }], null, false, 2899345588)
  }, [_vm._v("-->\n            ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteItemRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 1914607797)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b4d4588", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b4d4588"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/activity/activity_add.vue
// module id = 2746
// module chunks = 0